export default "__VITE_ASSET__eeb89799__"